
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Button,Modal,ButtonToolbar} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
// import {Checkbox} from 'react-icheck'
class ExportTyreExcelButton extends Component {

  constructor(...args){
    super(...args)
    this.refTableId = 'export-stock-'+Math.ceil(Math.random()*100);
    let data = []
    if (process.env.NODE_ENV === "development") {
      //data = [{itemnum:1,detail:"test",productcode:'abc',quantity:'10'}]
    }
    this.state = {show:false,data:data,_data:[],oneFill:false}
  }
  
  clearItem(){
    this.setState({data:[]}) 
  }

  setItem(nItem) {
    this.setState({_data:nItem})
  }

  addItem(nItem){
    let {data} = this.state
    
    let foundItem = false
    data.map((item,index)=>{
      if(item.itemnum===nItem.itemnum){
        foundItem = true
      }
      return item
    })
    if(!foundItem)
      data.push(nItem)
    this.setState({data:data})    
  }

  removeItem(rItem){
    let {data} = this.state
    data = data.reduce((rresult,item)=>{
      if(item.itemnum!==rItem.itemnum){
        rresult.push(item)
      }
      return rresult
    },[])
    this.setState({data:data})
  }

  onClick(){
    this.setState({show:true})
  }

  onHide(){
    this.setState({show:false})    
  }

  onTextChange(index,key,e){
    let {data} = this.state
    data[index][key] = {value:e.target.value}
    this.setState({data:data})
  }

  onTextBlur(index,key,colValue){
    let {data} = this.state
    data[index][key] = colValue.value
    this.setState({data:data})
  }

  onColumnClick(index,key,colValue){
    let {data} = this.state
    let value = (typeof colValue.value !=='undefined')?colValue.value:colValue   
    data[index][key] = {value:value}
    this.setState({data:data})
  }

  onOKClick(){
    this.setState({show:false})   
    let {messages} = this.props
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), messages['Warehouse List']+".xlsx")
  
  }

  onDeleteClick(index,e){
    let {btnDisplay} = this.props
    let {data,_data} = this.state
    if (btnDisplay==='')
        data.splice(index,1)
    else
        _data.splice(index,1)

    this.setState({data:data,_data:_data})
  }

  onOneCheckbox(e,value){
    let {data} = this.state
    data = data.map((item,index)=>{
      if(value){
        if(item.quantity*1===0){
          item['preQuantity'] = item.quantity
          item.quantity = 1        
        }
      }else{
        item.quantity = item.preQuantity!==undefined?item.preQuantity:'1'
      }
      return item
    })
    this.setState({data:data,oneFill:value})
  }

  

  renderInputColumn(item,index,key){
    if(item!==null && item!=='' && typeof item.value !=='undefined')
      return (<input autoFocus
        style={{display:'inline-block'}}
        className='form-control text-left'
        value={item.value}
        onBlur={ this.onTextBlur.bind(this,index,key,item) }
        onChange={ this.onTextChange.bind(this,index,key) }
      />)
    return (
      <div>{item}</div>
    )
  }

  renderRowData(){
    let {data,_data} = this.state
    let {messages,btnDisplay} = this.props
    let use_data = []
    if (btnDisplay==='') {
      use_data = data
    } else {
      use_data = _data
    }
    if(use_data.length===0){
      return (<tr><td colSpan={8}>{messages['No item']}</td></tr>)
    }
    return use_data.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td className='text-center'>{item.productcode}</td>
        <td className='text-center'>{item.detail}</td>
        <td className='text-center'>{item.tyre_model}</td>
        <td className='text-center'>{item.tyre_size}</td>
        <td className='text-center'>{item.retread_count}</td>
        <td className='text-center'>{item.tyre_mileage}</td>
        <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteClick.bind(this,index)}>{messages['Delete']}</Button></td>
      </tr>
    ))
  }

  renderTable(){
    let {messages} = this.props
    return (
      <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'100px'}}>หมายเลขยาง</th>
            <th className='text-center' style={{width:'90px'}}>ยี่ห้อยาง</th>            
            <th className='text-center' style={{width:'90px'}}>รุ่น</th>
            <th className='text-center' style={{width:'90px'}}>ขนาดยาง</th>
            <th className='text-center' style={{width:'90px'}}>จำนวนครั้งที่<br />หล่อดอก</th>
            <th className='text-center' style={{width:'90px'}}>จำนวน กม.</th>
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderDeleteTable(){
    let {data} = this.state
    return (
      <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>ลบ</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item,index)=>(
            <tr>
              <td><Button bsStyle={'danger'} onClick={this.onDeleteClick.bind(this,index)}>ลบ</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  renderReportPopup(){
    let {show} = this.state
    let {messages} = this.props
    return (
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{messages['Download Excel File']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box >
            <Box.Body>
              {/* <Checkbox 
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label={' '+messages['Add 1 For Item as 0']}
                value={oneFill}
                onChange={this.onOneCheckbox.bind(this)}
              /> */}
              {this.renderTable()}              
            </Box.Body>           
          </Box>          
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onOKClick.bind(this)}><FontAwesome name='download'/>&nbsp;{messages['Download File']}</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;{messages['Cancel']}</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>  
    )
  }

  render(){
    let {data} = this.state
    let {messages,showBtn} = this.props
    return (
      <div style={{display:(data.length>0)?'inline':'none'}}>
        {showBtn?<Button className='bg-green' onClick={this.onClick.bind(this)}>{data.length} {messages['Excel File']}</Button>:''}
        {this.renderReportPopup()}
      </div>
    )
  }
}

ExportTyreExcelButton.defaultProps = {
  showBtn:true,
  stockType:''
}

export default ExportTyreExcelButton = connect(
  (state) => ({messages: state.message.view.stock.ExportExcelButton}),null,null,{withRef:true}
)(ExportTyreExcelButton);





// WEBPACK FOOTER //
// ./src/view/tyre/stock/ExportTyreExcelButton.js